import { css } from 'styled-components';

export const antdSelect = css`
  .ant-select {
    font-family: inherit;
    width: 100%;
    height: ${({ theme }) => theme.sz.inputHeight};
    border: solid 1px ${({ theme }) => theme.black.a1};
    border-radius: 5px;
    transition: all 0.2s ease-in;
    position: relative;
    font-size: 0.867rem;
    color: ${({ theme }) => theme.baseBlue.a10};
    background-color: ${({ theme }) => theme.white.a10};

    .ant-select-selector {
      width: 100%;
      border: 0;
      position: absolute;
      bottom: 0;
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
      }
    }

    .ant-select-selector {
      border: 0 !important;
      margin-top: 25px;
    }

    &.ant-select-open,
    &.ant-select-focused {
      border-color: ${({ theme }) => theme.baseBlue.a10};
      box-shadow: 0 18px 30px -11px ${({ theme }) => theme.baseBlue.a10};

      .ant-select-selector {
        box-shadow: none;
      }
    }

    &.invalid {
      border-color: ${({ theme }) => theme.red.a10};

      &:focus {
        box-shadow: 0 18px 30px -11px ${({ theme }) => theme.red.a10};
      }
    }

    .ant-select-selector {
      height: 28px;
    }

    .ant-select-arrow {
      font-size: 20px;
      margin-top: 0;
    }
  }

  .ant-select-dropdown.select-dd-styled {
    font-size: 0.867rem;
    font-family: inherit;
    border: 1px solid ${({ theme }) => theme.black.a1};
    padding: 0;
    border-radius: 4px;

    .ant-select-item {
      height: 45px;
      line-height: 30px;
      font-weight: 400;
      border-top: 1px solid ${({ theme }) => theme.black.a1};
      font-size: 15px;
      letter-spacing: 0.25px;
      color: ${({ theme }) => theme.baseBlue.a6};
      &:first-child {
        border-top: none;
      }

      &.ant-select-item-option-active {
        color: ${({ theme }) => theme.baseBlue.a10};
        background-color: ${({ theme }) => theme.baseBlue.a0};
      }

      &.ant-select-item-option-selected {
        background-color: ${({ theme }) => theme.baseBlue.a10};
        color: ${({ theme }) => theme.white.a10};
        font-weight: 300;
      }
      &:hover {
        background-color: ${({ theme }) => theme.baseBlue.a10};
        color: ${({ theme }) => theme.white.a10};
      }
    }
  }
`;
